{
  "name": "everything.insure",
  "version": "2026.26.8",
  "scripts": {
    "ng": "ng",
    "start": "ng serve -c dev",
    "start_uat": "ng serve -c uat",
    "set-ver": "npx capacitor-set-version -v 2026.26.8 -b 92 --json && npm version 2026.26.8 --no-git-tag-version --allow-same-version",
    "serve:ios": "NODE_OPTIONS=--max-old-space-size=4096 ng serve -c dev --host=$(ipconfig getifaddr en0 || ipconfig getifaddr en1) --port=4200 --disable-host-check",
    "deploy:ios": "ng serve -c dev --host=$(ipconfig getifaddr en0 || ipconfig getifaddr en1) --port=4200 --disable-host-check & npx wait-on http://$(ipconfig getifaddr en0 || ipconfig getifaddr en1):4200 && LANG=en_US.UTF-8 LC_ALL=en_US.UTF-8 npx cap run ios --no-sync --target=00008110-0010484E0ED8401E",
    "sync-ios": "ng build && npx cap sync ios && npx cap open ios",
    "test-ios": "ng build && npx cap copy ios",
    "fix-version": "sed -i 's/VERSION_21/VERSION_11/g' android/capacitor-cordova-android-plugins/cordova.variables.gradle || true",
    "build-android-fix": "ng build -c $BUILD_ENV --output-hashing=all && npx cap sync android && npm run fix-version",
    "build": "npm run build-android-fix",
    "build_": "ng build | npx cap copy",
    "build_ios": "ng build -c production --output-hashing=all && npx cap sync ios && npx cap open ios",
    "build_ios_uat": "ng build -c uat && npx cap sync ios && npx cap open ios",
    "build_ios_staging": "ng build -c staging && npx cap sync ios && npx cap open ios",
    "build_ios_dev": "ng build -c dev && npx cap sync ios && npx cap open ios",
    "build_android": "ng build -c production --output-hashing=all && npx cap sync android && npx cap open android",
    "build_android_uat": "ng build -c uat && npx cap sync android && npx cap open android",
    "build_android_dev": "ng build -c dev && npx cap sync android && npx cap open android",
    "dev": "ng build --base-href '/central/' --configuration=dev",
    "uat": "ng build --base-href '/central/' --configuration=uat",
    "staging": "ng build --base-href '/central/' --configuration=staging --output-hashing=all",
    "india": "ng build --base-href '/central/' --configuration=india --output-hashing=all",
    "live": "ng build --base-href '/central/' --configuration=production --output-hashing=all",
    "live2": "ng build --base-href '/central/' --configuration=production2 --output-hashing=all",
    "test": "ng test",
    "lint": "ng lint",
    "storybook": "ng run policy:storybook",
    "build-storybook": "ng run policy:build-storybook",
    "postinstall": ""
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.18",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.18",
    "@angular/compiler": "^21.2.18",
    "@angular/core": "^21.2.18",
    "@angular/forms": "^21.2.18",
    "@angular/google-maps": "^21.2.14",
    "@angular/platform-browser": "^21.2.18",
    "@angular/platform-browser-dynamic": "^21.2.18",
    "@angular/router": "^21.2.18",
    "@aparajita/capacitor-biometric-auth": "^10.0.0",
    "@capacitor/android": "^7.4.5",
    "@capacitor/app": "^7.0.1",
    "@capacitor/browser": "^7.0.1",
    "@capacitor/camera": "^7.0.0",
    "@capacitor/cli": "^7.2.0",
    "@capacitor/clipboard": "^7.0.4",
    "@capacitor/core": "^7.2.0",
    "@capacitor/device": "^7.0.0",
    "@capacitor/dialog": "^7.0.1",
    "@capacitor/geolocation": "7.0.0",
    "@capacitor/ios": "^7.2.0",
    "@capacitor/live-updates": "^0.4.0",
    "@capacitor/preferences": "^7.0.4",
    "@capacitor/push-notifications": "^7.0.1",
    "@capacitor/splash-screen": "^7.0.1",
    "@capacitor/status-bar": "^7.0.2",
    "@capawesome/capacitor-app-update": "^8.0.3",
    "@capgo/capacitor-updater": "^8.47.5",
    "@datorama/akita": "^8.0.1",
    "@datorama/akita-ng-entity-service": "^8.0.0",
    "@datorama/akita-ng-router-store": "^8.0.0",
    "@ionic/pwa-elements": "^3.1.1",
    "@microsoft/signalr": "^10.0.0",
    "@ng-idle/core": "^14.0.0",
    "@ng-idle/keepalive": "^14.0.0",
    "@ng-select/ng-select": "^21.8.2",
    "@popperjs/core": "^2.11.4",
    "@sentry/angular": "^10.65.0",
    "accounting": "^0.4.1",
    "angular-accounting": "^1.0.0",
    "angular-animations": "^0.11.0",
    "angular-cc-library": "^3.0.1",
    "angular-datatables": "^19.0.0",
    "angular-svg-icon": "^13.0.0",
    "angularx-qrcode": "^21.0.5",
    "bootstrap": "^4.3.1",
    "chart.js": "^4.3.0",
    "datatables.net": "^1.11.3",
    "datatables.net-bs4": "^1.11.3",
    "datatables.net-dt": "^1.11.5",
    "google-libphonenumber": "^3.2.30",
    "html-to-pdfmake": "^2.4.6",
    "html2canvas": "^1.4.1",
    "html2pdf.js": "^0.10.1",
    "jquery": "^3.6.0",
    "jquery-validation": "^1.19.3",
    "jspdf": "^2.5.1",
    "lottie-web": "^5.9.1",
    "ngx-currency": "^19.0.0",
    "ngx-dropzone": "^3.1.0",
    "ngx-lottie": "^21.2.0",
    "ngx-mask": "^21.1.0",
    "ngx-slick-carousel": "^20.0.0",
    "onesignal-cordova-plugin": "5.2.15",
    "pdfmake": "^0.2.5",
    "rxjs": "^7.8.2",
    "slick-carousel": "^1.8.1",
    "tslib": "^2.3.1",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.19",
    "@angular-eslint/builder": "^21.4.0",
    "@angular-eslint/eslint-plugin": "^21.4.0",
    "@angular-eslint/eslint-plugin-template": "^21.4.0",
    "@angular-eslint/schematics": "^21.4.0",
    "@angular-eslint/template-parser": "^21.4.0",
    "@angular/build": "^21.2.19",
    "@angular/cli": "^21.2.19",
    "@angular/compiler-cli": "^21.2.18",
    "@datorama/akita-ngdevtools": "^6.0.1",
    "@storybook/addon-docs": "^10.5.0",
    "@storybook/addon-links": "^10.5.0",
    "@storybook/angular": "^10.5.0",
    "@types/datatables.net": "^1.10.21",
    "@types/inputmask": "^5.0.3",
    "@types/jquery": "^3.5.14",
    "@types/lodash": "^4.14.180",
    "@types/node": "^17.0.21",
    "@types/react": "^18.2.21",
    "@typescript-eslint/eslint-plugin": "^8.63.0",
    "@typescript-eslint/parser": "^8.63.0",
    "@zxcvbn-ts/core": "^3.0.1",
    "@zxcvbn-ts/language-common": "^3.0.1",
    "@zxcvbn-ts/language-en": "^3.0.1",
    "concurrently": "^7.0.0",
    "eslint": "^8.57.0",
    "jsdom": "^29.1.1",
    "lodash.clonedeep": "^4.5.0",
    "react": "^18.2.0",
    "react-dom": "^18.2.0",
    "storybook": "^10.5.0",
    "typescript": "5.9.3",
    "vitest": "^4.1.10"
  },
  "overrides": {
    "stylus": "0.0.1-security"
  },
  "optionalDependencies": {
    "@rollup/rollup-darwin-arm64": "4.22.4",
    "@rollup/rollup-linux-x64-gnu": "4.22.4"
  }
}
